import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { About } from './components/About';
import { Services } from './components/Services';
import { WhyUs } from './components/WhyUs';
import { Testimonials } from './components/Testimonials';
import { PromiseSection } from './components/Promise';
import { Urgency } from './components/Urgency';
import { CTA } from './components/CTA';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { WhatsAppFloat } from './components/WhatsAppFloat';
export function App() {
  return <div className="min-h-screen bg-brand-ivory font-sans text-brand-charcoal selection:bg-brand-gold/30" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Hook data-id="element-4" />
        <About data-id="element-5" />
        <Services data-id="element-6" />
        <WhyUs data-id="element-7" />
        <Testimonials data-id="element-8" />
        <PromiseSection data-id="element-9" />
        <Urgency data-id="element-10" />
        <CTA data-id="element-11" />
        <FAQ data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
      <WhatsAppFloat data-id="element-14" />
    </div>;
}